<template>
    <div class="statistic__row" v-if="workStatInfo.workers.length">
        <div class="statistic__row__time" @click="openBotStat" style="border-color: #7457ff">
            <p>{{parseDate(workStatInfo.datetime)}}</p>
            <span>-</span>
            <p>{{parseDate(workStatInfo.datetime, true)}}</p>
            <img :class="{ rotate: open }" src="../../assets/images/down-arrow.svg" alt="open">
        </div>
        <div class="statistic__information" v-show="open">
            <div class="statistic__row__info workers" v-for="worker in workStatInfo.workers" style="border-color: #8891b9">
                <div class="info">
                    <span>Имя:</span>
                    <p>{{worker.worker_desc}}</p>
                </div>
                <div class="info">
                    <span>Id:</span>
                    <p>{{worker.worker_id }}</p>
                </div>
                <div class="info">
                    <span>Время работы:</span>
                    <p>{{worker.work_time}} min</p>
                </div>
                <div class="info">
                    <span>Проверено:</span>
                    <p>{{worker.as_checks}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AntiScamWorkStatistic",
    props: ["workStatInfo"],
    data () {
        return {
            open: false
        }
    },
    methods: {
        parseDate(time, end) {
            const d = new Date(time);

            d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());

            if (end) {
                d.setDate(d.getDate() + 1)
            }

            return d.toLocaleString("ru-RU", {
                timeZone: "Europe/Moscow",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
            });
        },
        openBotStat () {
            this.open = !this.open
        }
    }
}
</script>
